import request from '@/utils/request'

export function getTeacherList(params) {
  return request({
    url: '/api/admin/Teacher',
    method: 'get',
    params
  })
}

export function getTeacherDetail(id) {
  return request({
    url: `/api/admin/Teacher/${id}`,
    method: 'get'
  })
}

// PUT /api/admin/Teacher - Create or update teacher (uses UpdateTeacherCommand)
export function upsertTeacher(data) {
  return request({
    url: '/api/admin/Teacher',
    method: 'put',
    data
  })
}

export function updateTeacher(id, data) {
  return request({
    url: `/api/admin/Teacher/${id}`,
    method: 'put',
    data
  })
}

export function deleteTeacher(id) {
  return request({
    url: `/api/admin/Teacher/${id}`,
    method: 'delete'
  })
}

export function getTeacherSchedule(id, params) {
  return request({
    url: `/api/admin/Teacher/${id}/schedule`,
    method: 'get',
    params
  })
}

export function getTeacherBookings(id, params) {
  return request({
    url: `/api/admin/Teacher/${id}/bookings`,
    method: 'get',
    params
  })
}

// Get all teachers for export
export function getTeachersForExport(params) {
  return request({
    url: '/api/admin/Teacher',
    method: 'get',
    params
  })
}
